import $ from 'jquery';
window.$ = window.jQuery = require('jquery');

import React, {
    Fragment,
    useCallback,
    useState,
    useEffect,
    useRef,
    useReducer,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../Services/translation';
import {
    query,
    searchFacetChange,
    searchSliderFacetChange,
} from '../Actions/FacetedSearch.action';
import { useStateWithCallbackLazy } from 'use-state-with-callback';
import { Foundation } from 'foundation-sites/js/foundation.core';

const FacetedSearchGroup = ({ group }) => {
    const [collapsed, setCollapsed] = useStateWithCallbackLazy(true);
    const [currentGroup, setCurrentGroup] = useStateWithCallbackLazy(
        Object.assign({}, group),
    );

    const showLessItemCount = useRef(5);
    const list = useRef(null);

    const toggleShowMore = useCallback(() => {
        setCollapsed(!collapsed);
    }, [setCollapsed]);

    useEffect(() => {
        const arr = collapsed
            ? !group.isSlider
                ? group.options
                      .filter(
                          item =>
                              item.quantity !== 0 &&
                              !isNaN(item.quantity) &&
                              item.quantity !== null,
                      )
                      .slice(0, 5)
                : group.options
            : group.options;

        setCurrentGroup({ ...currentGroup, options: arr });
    }, [collapsed, group]);

    return (
        <Fragment>
            <li className="accordion-item is-active" data-accordion-item>
                <a href="#" className="accordion-title">
                    {group.label}
                </a>
                <div className="accordion-content" data-tab-content ref={list}>
                    <ul className="faceted-search__group">
                        {!currentGroup.isSlider ? (
                            currentGroup.options
                                .filter(
                                    item =>
                                        item.quantity != 0 &&
                                        !isNaN(item.quantity) &&
                                        item.quantity != null,
                                )
                                .map((item, itemIndex, array) => (
                                    <li
                                        key={`${item.label}-${itemIndex}`}
                                        className="faceted-search__item"
                                    >
                                        <FacetedFilterCheckbox
                                            item={item}
                                            group={group}
                                        />
                                    </li>
                                ))
                        ) : (
                            <li key={`${group.label}`}>
                                <FacetedFilterRange group={currentGroup} />
                            </li>
                        )}
                        {!currentGroup.isSlider &&
                            currentGroup.options.filter(
                                item =>
                                    item.quantity != 0 &&
                                    !isNaN(item.quantity) &&
                                    item.quantity != null,
                            ).length >= showLessItemCount.current && (
                                <li onClick={toggleShowMore}>
                                    <button className="button clear show-more">
                                        {currentGroup.options.length >=
                                            showLessItemCount.current &&
                                            collapsed && (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-plus-circle"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                    <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                                                </svg>
                                            )}
                                        {currentGroup.options.length >=
                                            showLessItemCount.current &&
                                            !collapsed && (
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="16"
                                                    height="16"
                                                    fill="currentColor"
                                                    className="bi bi-dash-circle"
                                                    viewBox="0 0 16 16"
                                                >
                                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                    <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z" />
                                                </svg>
                                            )}
                                        {`${
                                            collapsed
                                                ? translate('filter.showmore')
                                                : translate('filter.showless')
                                        }`}
                                    </button>
                                </li>
                            )}
                    </ul>
                </div>
            </li>
        </Fragment>
    );
};

const FacetedFilterSwitch = ({ item, group }) => {
    const dispatch = useDispatch();
    const onChange = useCallback(
        (group, item) => dispatch(searchFacetChange(group, item)),
        [dispatch],
    );

    return (
        <>
            {group.options.some(item => item.key == 'withdrawn') && (
                <div>
                    <div className="switch">
                        <input
                            className="switch-input"
                            id="discontiunedSwitch"
                            type="checkbox"
                            name="discontiunedSwitch"
                            onChange={event => onChange(group, item)}
                        />
                        <label
                            className="switch-paddle"
                            htmlFor="discontiunedSwitch"
                        >
                            <span>
                                {translate('filter.discontinued.switch')}
                            </span>
                        </label>
                    </div>
                </div>
            )}
        </>
    );
};

const FacetedFilterCheckbox = ({ item, group }) => {
    const dispatch = useDispatch();
    const onChange = useCallback(
        (group, item) => {
            dispatch(searchFacetChange(group, item));
        },
        [dispatch],
    );

    return (
        <label className="faceted-filter">
            <input
                className="faceted-filter__input"
                type="checkbox"
                onChange={event => onChange(group, item)}
                checked={
                    group.selectedOptions != null &&
                    group.selectedOptions.includes(item.id)
                }
            />
            <span className="faceted-filter__label">
                {item.label}
                {!isNaN(item.quantity) && item.quantity != null && (
                    <span className="faceted-filter__quantity">
                        &nbsp;({item.quantity})
                    </span>
                )}
            </span>
        </label>
    );
};

const FacetedFilterRange = ({ group }) => {
    const dispatch = useDispatch();

    const { resetRangeFilter } = useSelector(state => state.facetedSearch);

    const getPercentPosition = value => {
        const percentage = (value - min) / (max - min);
        const startOffset = 3.5;
        const endOffset = startOffset * 2 * percentage;
        return percentage * 100 + startOffset - endOffset + '%';
    };

    const onFinalChangeMin = useCallback(
        (group, target, maxValue) => {
            setSelectedOptions([parseInt(target.value), maxValue]);
            dispatch(searchSliderFacetChange(group, target.value, maxValue));
        },
        [dispatch],
    );

    const onFinalChangeMax = useCallback(
        (group, target, minValue) => {
            setSelectedOptions([minValue, parseInt(target.value)]);
            dispatch(searchSliderFacetChange(group, minValue, target.value));
        },
        [dispatch],
    );

    const onChangeMax = e => {
        setMaxValue(e.target.value);
        setOutputTwoValue(getPercentPosition(e.target.value));
    };

    const onChangeMin = e => {
        setMinValue(e.target.value);
        setOutputOneValue(getPercentPosition(e.target.value));
    };

    const [selectedOptions, setSelectedOptions] = useState(
        group.selectedOptions?.length > 0
            ? group.selectedOptions
                  .map(opt => parseInt(opt))
                  .sort((a, b) => a - b)
            : [],
    );

    const [minValue, setMinValue] = useState(
        parseInt(
            selectedOptions?.length > 0
                ? selectedOptions[0]
                : group.options?.length > 0
                ? group.options[0].label
                : 1,
        ),
    );

    const [maxValue, setMaxValue] = useState(
        parseInt(
            selectedOptions?.length > 0
                ? selectedOptions[1]
                : group.options?.length > 0
                ? group.options[group.options.length - 1].label
                : 9999,
        ),
    );

    const min = parseInt(
        group.options?.length > 0 ? group.options[0].label : 1,
    );

    const max = parseInt(
        group.options?.length > 0
            ? group.options[group.options.length - 1].label
            : 9999,
    );

    const [outputOneValue, setOutputOneValue] = useState(
        getPercentPosition(minValue),
    );

    const [outputTwoValue, setOutputTwoValue] = useState(
        getPercentPosition(maxValue),
    );

    const inclRangeStyle = {
        left: ((minValue - min) / (max - min)) * 100 + '%',
        width:
            ((maxValue - min) / (max - min) - (minValue - min) / (max - min)) *
                100 +
            '%',
    };

    useEffect(() => {
        if (resetRangeFilter === group.id) {
            setMinValue(min);
            setMaxValue(max);
            setOutputOneValue(getPercentPosition(min));
            setOutputTwoValue(getPercentPosition(max));
        }
    }, [setSelectedOptions, max, min, group, resetRangeFilter]);

    return minValue > 0 && maxValue < 9999 && min !== max ? (
        <div className="faceted-filter">
            <section className="range-slider container">
                <label
                    htmlFor={`rangeOne_${group.id.replace('-', '_')}`}
                    style={{ display: 'none' }}
                >
                    Minimum value
                </label>
                <label
                    htmlFor={`rangeTwo_${group.id.replace('-', '_')}`}
                    style={{ display: 'none' }}
                >
                    Maximum value
                </label>
                <span
                    id={`outputOne_${group.id.replace('-', '_')}`}
                    key={`outputOne_${group.id.replace('-', '_')}`}
                    className="output"
                    style={{ left: outputOneValue }}
                >
                    {minValue}
                </span>
                <span
                    id={`outputTwo_${group.id.replace('-', '_')}`}
                    key={`outputTwo_${group.id.replace('-', '_')}`}
                    className="output"
                    style={{ left: outputTwoValue }}
                >
                    {maxValue}
                </span>
                <span
                    id={`fullRange_${group.id.replace('-', '_')}`}
                    key={`fullRange_${group.id.replace('-', '_')}`}
                    className="full-range"
                ></span>
                <span
                    id={`inclRange_${group.id.replace('-', '_')}`}
                    key={`inclRange_${group.id.replace('-', '_')}`}
                    className="incl-range"
                    style={inclRangeStyle}
                ></span>
                <input
                    id={`rangeOne_${group.id.replace('-', '_')}`}
                    key={`rangeOne_${group.id.replace('-', '_')}`}
                    value={minValue}
                    aria-valuemin={min}
                    aria-valuemax={max}
                    aria-valuenow={minValue}
                    min={min}
                    max={max}
                    step="1"
                    type="range"
                    onChange={e => onChangeMin(e)}
                    onMouseUp={e => onFinalChangeMin(group, e.target, maxValue)}
                />
                <input
                    id={`rangeTwo_${group.id.replace('-', '_')}`}
                    key={`rangeTwo_${group.id.replace('-', '_')}`}
                    value={maxValue}
                    aria-valuemin={min}
                    aria-valuemax={max}
                    aria-valuenow={maxValue}
                    min={min}
                    max={max}
                    step="1"
                    type="range"
                    onChange={e => onChangeMax(e)}
                    onMouseUp={e => onFinalChangeMax(group, e.target, minValue)}
                />
            </section>
        </div>
    ) : (
        <label className="faceted-filter">{min}</label>
    );
};

const FacetedSearch = ({ showButton }) => {
    const dispatch = useDispatch();
    const {
        facetFilters: globalFacetFilters,
        navigationTheme,
        productsViewCachedId,
        totalCount,
    } = useSelector(state => state.facetedSearch);

    const [facetFilters, setFacetFilters] = useState(globalFacetFilters || []);
    const [initialized, setInitialized] = useState(false);

    const previousCachedId = useRef(productsViewCachedId);
    useEffect(() => {
        if (previousCachedId.current !== productsViewCachedId) {
            setFacetFilters(globalFacetFilters);
            previousCachedId.current = productsViewCachedId;
        }
    }, [globalFacetFilters, productsViewCachedId]);

    useEffect(() => {
        dispatch(query(window.location.search.substr(1) || '', false));
    }, [dispatch]);

    useEffect(() => {
        if (facetFilters.length > 0 && !initialized) {
            $(document).foundation();
            Foundation.reInit('accordion');

            $('.c-filter__accordion').each(function () {
                var $acc = $(this);
                var $openSections = $acc.find(
                    '.accordion-item.is-active .accordion-content',
                );
                $openSections.each(function (i, section) {
                    $acc.foundation('up', $(section));
                });
            });
            setInitialized(true);
        }
    }, [globalFacetFilters]);

    function ClickHandler() {
        $('#sideBarNavigation').foundation('close');
    }

    return (
        navigationTheme !== 'category' &&
        facetFilters && (
            <>
                <ul
                    className="accordion c-filter__accordion"
                    data-accordion
                    data-allow-all-closed="true"
                >
                    {facetFilters
                        .filter(group => group.id !== 'custom_product_status')
                        .map((group, groupIndex) => (
                            <FacetedSearchGroup
                                key={`${group.label}-${groupIndex}`}
                                group={group}
                            />
                        ))}
                </ul>
                {facetFilters
                    .filter(group => group.id === 'custom_product_status')
                    .map(group => (
                        <FacetedFilterSwitch
                            key={group.id}
                            item={group.options.find(
                                item => item.key == 'withdrawn',
                            )}
                            group={group}
                        />
                    ))}

                <div
                    id="filterPillsContainer"
                    className="c-filter__selected"
                ></div>

                {totalCount >= 0 && showButton && (
                    <div className="c-filter__off-canvas__footer">
                        <button
                            onClick={ClickHandler}
                            className="button btn-black"
                        >
                            {translate('filter.showmoreproducts.first') +
                                totalCount +
                                translate('filter.showmoreproducts.last')}
                        </button>
                    </div>
                )}
            </>
        )
    );
};

export default FacetedSearch;
